import enUS from './en_US';
import zhCN from './zh_CN';
export default {
  'en-US': enUS,
  'zh-CN': zhCN
};